import {
  useEffect,
  useState,
} from 'react';

import watchCountedResponses from '../utils/watchCountedResponses';

// Developer-facing, dev and demo builds only: a full-screen alarm that stays
// until dismissed whenever the server answered with a status that bans in
// production. Wording is not translated on purpose, it never reaches a user.
const meaning = {
  404: 'scan / malformed open-route request: BANNED ON FIRST HIT in production',
  401: 'refused credential: banned after 10 in 10 minutes in production',
};

function BanConditionOverlay() {
  const [events, setEvents] = useState([]);

  useEffect(
    () => watchCountedResponses((event) => {
      setEvents((previous) => [...previous, event].slice(-20));
    }),
    [],
  );

  if (!events.length) return null;

  return (
    <div
      className="fixed inset-0 overflow-auto bg-pxBanner p-8 font-mono text-white"
      style={{ zIndex: 10000 }}
    >
      <h1 className="mb-2 text-3xl font-bold">BAN CONDITION</h1>
      <p className="mb-6">
        This client sent a request the production servers would ban. Fix it before release.
      </p>

      <ul className="mb-8 space-y-4">
        {events.map((event) => (
          <li key={`${event.at.toISOString()}-${event.url}`} className="border-l-4 border-white pl-4">
            <div className="font-bold">
              {`${event.status} ${event.method} ${event.url}`}
            </div>
            <div>{meaning[event.status]}</div>
            {(event.kind)
              ? <div>{`kind: ${event.kind}`}</div>
              : null}
            {(event.details)
              ? <div className="whitespace-pre-wrap break-all opacity-80">{event.details}</div>
              : null}
            <div className="opacity-60">{event.at.toLocaleTimeString()}</div>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className="rounded border-2 border-white px-6 py-2 font-bold hover:bg-white hover:text-pxUiAlert"
        onClick={() => setEvents([])}
      >
        Dismiss
      </button>
    </div>
  );
}

export default BanConditionOverlay;
